export default __webpack_public_path__ + "static/damage-f7578477159eb1164998f06272153924.png";